import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class MailInfoConfig extends Http {
  [x: string]: any

  public async getMailInfoList(data: NLoginApi.getMailInfoListRequestData) {
    return await super.request<NLoginApi.getMailInfoListResponse>({
      url: '/mail/getMailInfoList',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getMailInfoDetail(data: NLoginApi.getMailInfoDetailRequestData) {
    return await super.request<NLoginApi.getMailInfoDetailResponse>({
      url: '/mail/getMailInfoDetail',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async addMailInfo(data: NLoginApi.addMailInfoRequestData) {
    return await super.request<NLoginApi.addMailInfoResponse>({
      url: '/mail/addMailInfo',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async deleteMailInfo(data: NLoginApi.deleteMailInfoRequestData) {
    return await super.request<NLoginApi.deleteMailInfoResponse>({
      url: '/mail/deleteMailInfo',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async updateMailInfo(data: NLoginApi.updateMailInfoRequestData) {
    return await super.request<NLoginApi.updateMailInfoResponse>({
      url: '/mail/updateMailInfo',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getDistinctMailOrgName(data: NLoginApi.getDistinctMailOrgNameRequestData) {
    return await super.request<NLoginApi.getDistinctMailOrgNameResponse>({
      url: '/mail/getDistinctMailOrgName',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default MailInfoConfig
